import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const DEFAULT_CREDITS = { balance: 0, totalPurchased: 0, totalUsed: 0 };

const useCredits = (user) => {
  const [credits, setCredits] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setCredits(null);
      setLoading(false);
      return;
    }

    const userRef = doc(db, 'users', user.uid);
    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        setCredits({ ...DEFAULT_CREDITS, ...(data.credits || {}) });
      } else {
        setCredits({ ...DEFAULT_CREDITS });
      }
      setLoading(false);
    }, (error) => {
      console.error('Error listening to credits:', error);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [user]);

  return { credits, loading };
};

export default useCredits;
